import { PlusOutlined } from '@ant-design/icons'
import { formatMinutesToParts } from '@components/_SiteWide/Form/HourMinuteInput'
import { BBDTag, GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Popover, Tooltip } from 'antd'
import React, { useState } from 'react'

export function OverrideActionCellRenderer({ overrideForm, hadEdits, overrideDwell, open, handleOpenChange }) {
  const content = overrideDwell ? (
    <BBDTag success>{formatMinutesToParts(overrideDwell)}</BBDTag>
  ) : (
    <GraviButton style={{ maxHeight: '24px' }} icon={<PlusOutlined />} />
  )

  const wrapper = hadEdits ? (
    <Tooltip title='Save or discard edits before setting an override.'>
      <div>
        {overrideDwell ? content : <GraviButton style={{ maxHeight: '24px' }} icon={<PlusOutlined />} disabled />}
      </div>
    </Tooltip>
  ) : (
    <Popover
      title={<Texto weight='bold'>Override Dwell Time</Texto>}
      trigger='click'
      content={overrideForm}
      open={open}
      onOpenChange={handleOpenChange}
      overlayStyle={{ width: '300px' }}
    >
      {content}
    </Popover>
  )

  return (
    <Horizontal justifyContent='center' style={{ overflow: 'visible' }} verticalCenter>
      {wrapper}
    </Horizontal>
  )
}
